import { useRef, useState } from "react";
import { Upload } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useToast } from "@/components/ui/toast";
import { useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { queryKeys } from "@/lib/queries";

export function KnowledgeUploadButton() {
  const inputRef = useRef<HTMLInputElement>(null);
  const [busy, setBusy] = useState(false);
  const toast = useToast();
  const qc = useQueryClient();

  const onPick = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setBusy(true);
    try {
      const form = new FormData();
      form.append("file", file);
      form.append("title", file.name.replace(/\.[^.]+$/, ""));
      form.append("category", "upload");
      await api("/api/knowledge/upload", { method: "POST", body: form });
      toast.success("Document uploaded", file.name);
      await qc.invalidateQueries({ queryKey: queryKeys.knowledge });
    } catch (err) {
      toast.error("Upload failed", err instanceof Error ? err.message : undefined);
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <Button
        variant="outline"
        onClick={() => inputRef.current?.click()}
        disabled={busy}
      >
        <Upload className="h-4 w-4" />
        {busy ? "Uploading..." : "Upload file"}
      </Button>
      <input
        ref={inputRef}
        type="file"
        accept=".md,.txt,.json,text/*"
        className="hidden"
        onChange={onPick}
      />
    </>
  );
}
